export const ASYNC_SESSION_STATUSES = {
  pending: 'pending',
  error: 'complete_error',
  success: 'complete_success',
} as const;
